/* EarthBased - close the search suggestions dropdown, 22 Aug 2026
   Loaded deferred from snippets/rapid-search-settings.liquid.

   THE BUG (owner: "search bar recommendations is not closing when i click on
   other places")
   The theme fills .sarch-results with markup and never empties or hides it
   again. The panel is position:absolute and visible whenever it has content,
   so once a shopper types anything the suggestions sit over the page until
   they navigate away. There is no outside-click handler anywhere in the
   theme - this is not caused by the 22 Aug work, which only restyled the
   panel and changed the badge wording.

   THE FIX
   Hide on pointerdown outside the search form, or on Escape. Show again the
   moment the field is focused or typed in.

   Deliberately hides with a class rather than emptying .sarch-results: the
   theme's own script owns that element's contents, and wiping them would
   race with whatever it does next. A class it does not know about cannot
   interfere.

   pointerdown, not click: it fires before focus moves, so the panel is gone
   by the time the tap lands on whatever is underneath.

   Capture phase, so a handler further down that stops propagation cannot
   swallow it.

   To revert: delete this file and its script tag in
   snippets/rapid-search-settings.liquid, plus the .eb-search-hidden rule in
   assets/eb-predictive-search.css. */

(function () {
  var HIDDEN = 'eb-search-hidden';

  function panels() {
    return document.querySelectorAll('.sarch-results');
  }

  function hideAll() {
    var list = panels();
    for (var i = 0; i < list.length; i++) list[i].classList.add(HIDDEN);
  }

  // The form is the "inside" boundary: the input, the button and the results
  // panel all live within it, so a click anywhere in it should keep the panel
  // open. Falls back to the panel's own parent if the markup ever changes.
  function scopeOf(panel) {
    return panel.closest('form') || panel.parentElement;
  }

  document.addEventListener('pointerdown', function (e) {
    var list = panels();
    for (var i = 0; i < list.length; i++) {
      var scope = scopeOf(list[i]);
      if (scope && !scope.contains(e.target)) list[i].classList.add(HIDDEN);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') hideAll();
  });

  // Any interaction with a search field re-opens its panel.
  function reopenFrom(target) {
    if (!target || !target.closest) return;
    var form = target.closest('form');
    if (!form) return;
    var list = form.querySelectorAll('.sarch-results');
    for (var i = 0; i < list.length; i++) list[i].classList.remove(HIDDEN);
  }

  document.addEventListener('focusin', function (e) { reopenFrom(e.target); });
  document.addEventListener('input', function (e) { reopenFrom(e.target); });
})();
